<template>
  <div class="py-1 px-2 mb-3 bg-white shadow border-start border-4 border-primary">
    <div class="d-flex justify-content-between align-items-top">
      <div class="col my-auto fw-bold">{{ apiKey.name }}</div>

      <div>
        <small class="me-4 text-muted">Erstellt von {{ apiKey.createdBy }}</small>
        <button type="button" class="btn btn-sm" @click="deleteApiKeyRequest()" title="API Key löschen">
          <font-awesome-icon icon="trash" />
        </button>
      </div>
    </div>

    <p class="text-muted mb-1">
      <small>{{ apiKey.description }}</small>
    </p>

    <div class="row text-muted mx-0">
      <div class="col-4 text-start ps-0">
        <small class="fw-bold">Erstellt am: </small>
        <small>{{ dateConverter(apiKey.createdAt) + ' Uhr' }}</small>
      </div>

      <div class="col-4 text-center">
        <small class="fw-bold">Gültig bis: </small>
        <small>{{ apiKey.expiresAt != null ? dateConverter(apiKey.expiresAt) + ' Uhr' : '-' }}</small>
      </div>

      <div class="col-4 text-end">
        <small class="fw-bold">Zuletzt verwendet: </small>
        <small>{{ apiKey.lastUsedAt != null ? dateConverter(apiKey.lastUsedAt) + ' Uhr' : '-' }}</small>
      </div>
    </div>

    <div class="col-2 my-auto"></div>

    <div class="col-2 text-end my-auto"></div>
  </div>

  <ConfirmationAlert ref="confirmationAlertRef" @confirm="authStore.deleteApiKey(apiKey.id)" />
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, ref } from 'vue';

  import { useAuthStore } from '@/stores/authStore';

  import { ApiKey } from '@/models/AuthModels';
  import ConfirmationAlert from '@/components/ConfirmationAlert.vue';
  //#endregion

  const { apiKey } = defineProps({
    apiKey: {
      type: Object as PropType<ApiKey>,
      required: true,
    },
  });

  const authStore = useAuthStore();

  function dateConverter(date: Date): string {
    const d = new Date(date);
    return d.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  //#region Confirmation Alert
  const confirmationAlertRef = ref();

  function deleteApiKeyRequest() {
    confirmationAlertRef.value?.showAlert(
      'API Key löschen',
      `Möchten Sie den API Key "${apiKey.name}" unwiderruflich lösche?`,
      'danger',
      '',
      'danger',
      'text-white'
    );
  }
  //#endregion
</script>
